import PropTypes from 'prop-types';
import React from 'react';

export const Givebutter = ({
  givebutterCampaignID,
}) => {
  if (!givebutterCampaignID) return null;

  return (
    <givebutter-widget id={givebutterCampaignID} align="center" />
  );
};

Givebutter.propTypes = {
  givebutterCampaignID: PropTypes.string.isRequired,
};
